import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import popupTemplate from 'text!../../../templates/songIdentifiedDetail/SongIdentifiedDetailPopup.html';

const SongIdentifiedDetailPopupView = Backbone.View.extend({

    template : _.template(popupTemplate),

    

    initialize : function(options) {
        this.isTrebblePlayingMusic = options.isTrebblePlayingMusic;
    },


    events : {
        "click #closeBtn" : "closePopup",
        "click #browseAlbumBtn" : "browseAlbum",
        "click #browseArtistBtn" : "browseArtist",
        "click #playFromYoutubeBtn" : "playFromYoutube",
        "click #updateTitleAndArtist" : "updateSongOfCurrentPlayingSongExceptCoverArt",
        "click #updateLocalSongInfoBtn" : "updateSongOfCurrentPlayingSong"
    },

    closePopup : function(){
        this.$el.popup("close");
    },
    
    

    browseAlbum : function(){
        this.trigger("browseAlbum", this.model);
        this.$el.popup("close");
    },
    
    browseArtist : function(){
        window.history.back();
        this.trigger("browseArtist", this.model);
    },
    
    playFromYoutube : function(){
        
        this.trigger("playFromYoutube", this.model);
        this.$el.popup("close");
    },
    
    updateSongOfCurrentPlayingSong: function(){
        
        this.trigger("updateSongOfCurrentPlayingSong", this.model);
        this.$el.popup("close");
    },
    
    updateSongOfCurrentPlayingSongExceptCoverArt : function(){
        this.trigger("updateSongOfCurrentPlayingSongExceptCoverArt",this.model);
        this.$el.popup("close");
    },


    

    render : function() {
        this.$el.html(this.template({"model":this.model,"isTrebblePlayingMusic": this.isTrebblePlayingMusic}));
        this.setElement(this.$el.find("div").first());
        const elementId = this.$el.attr('id');
        this.$el.on({
            popupbeforeposition: (function() {
                //  const maxHeight = $( window ).height() - 60 + "px";
                const width = $( window ).width() - 20 + "px";
                // this.$el.css( "height", maxHeight );
                this.$el.css( "width", width );
            }).bind(this)
        });
        this.$el.on({
            popupafterclose: (function() {
                this.remove();
                this.undelegateEvents();
                
            }).bind(this)});
        $.mobile.pageContainer.prepend(this.$el);
        this.$el.popup({transition:"fade", dismissible: false,  tolerance: "0,0"});
        if(elementId)
        {
            const screenPopup$el = $("#"+elementId + "-screen");
            $.mobile.pageContainer.remove("#"+elementId + "-screen");
            $.mobile.pageContainer.prepend(screenPopup$el);
        }
        
        this.$el.enhanceWithin();
        Utils.getInstance().closeCurrentJQMPopup().then((function(){
            this.$el.popup('open' );
        }).bind(this));
        return this;
    }

});

export default SongIdentifiedDetailPopupView;